export const validatePhoneNumber = (phoneNumber) => {
  const pattern = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,4}$/;
  return pattern.test(phoneNumber);
};
